<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import InfoCard from './components/InfoCard.vue'
import InfoForm from './components/InfoForm.vue'

export default {
  components: { InfoCard, InfoForm },
  setup() {
    const store = useStore()

    // 是否提交过
    const hasInfo = computed(() => {
      return !!store.getters.getUserSelection
    })

    return {
      hasInfo,
    }
  },
}
</script>
<template>
  <div class="page">
    <InfoCard />
    <InfoForm :hasInfo="hasInfo" />
  </div>
</template>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background-color: #ffffff;
}
</style>
